module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-zyzq.df491540.png";